import { useField, useFormikContext } from 'formik';
import { Field, Select, type FieldConfig, type SelectProps } from '@kolking/react-ui';

import { useSpec } from './YupSpecContext';

export interface FormSelectProps extends FieldConfig, SelectProps {
  name: string;
}

export const FormSelect = ({
  id,
  name,
  label,
  help,
  className,
  disabled = false,
  required,
  children,
  ...props
}: FormSelectProps) => {
  const { isSubmitting, submitCount } = useFormikContext();
  const [{ value, ...field }, meta] = useField<unknown>(name);
  const spec = useSpec();
  const error = meta.touched || submitCount ? meta.error : undefined;

  return (
    <Field
      className={className}
      required={spec.isRequired(name, required)}
      label={spec.label(name, label)}
      help={help}
      id={id ?? name}
    >
      <Select
        {...props}
        {...field}
        id={id ?? name}
        disabled={spec.isDisabled(name, disabled || isSubmitting)}
        error={error}
        value={typeof value === 'string' ? value : ''}
        children={children}
      />
    </Field>
  );
};
